import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Printer, Download, Loader2 } from "lucide-react";
import { fetchPdfUrl, downloadPdf } from "../lib/pdf";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";

export default function Certificato() {
  const { id } = useParams();
  const [url, setUrl] = useState(null);
  const [numero, setNumero] = useState("");
  const frame = useRef(null);

  useEffect(() => {
    let u;
    fetchPdfUrl(id).then((x) => { u = x; setUrl(x); });
    api.get(`/garanzie/${id}`).then((r) => setNumero(r.data.numero));
    return () => u && URL.revokeObjectURL(u);
  }, [id]);

  const print = () => {
    try { frame.current.contentWindow.focus(); frame.current.contentWindow.print(); }
    catch { window.open(url, "_blank"); }
  };

  return (
    <div className="flex min-h-screen flex-col bg-[#1B2433]">
      <header className="flex flex-wrap items-center justify-between gap-3 border-b border-white/10 bg-[#0F1B2D] px-6 py-4">
        <div className="flex items-center gap-4">
          <Button variant="ghost" asChild className="text-slate-200 hover:bg-white/10 hover:text-white" data-testid="certificato-back-btn">
            <Link to={`/garanzie/${id}`}><ArrowLeft className="mr-1 h-4 w-4" /> Indietro</Link>
          </Button>
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#D4B98A]">Contratto di garanzia</div>
            <div className="font-mono text-sm font-bold text-white" data-testid="certificato-numero">{numero}</div>
          </div>
        </div>
        <div className="flex gap-2">
          <Button onClick={print} disabled={!url} variant="outline" className="border-[#B08D57] bg-transparent text-[#E9DCC4] hover:bg-[#B08D57]/15 hover:text-white" data-testid="certificato-print-btn">
            <Printer className="mr-1 h-4 w-4" /> Stampa
          </Button>
          <Button onClick={() => downloadPdf(id, numero)} disabled={!url} className="bg-[#B08D57] text-white hover:bg-[#96764A]" data-testid="certificato-download-btn">
            <Download className="mr-1 h-4 w-4" /> Scarica PDF
          </Button>
        </div>
      </header>
      {url ? (
        <iframe ref={frame} src={url} title="Contratto di garanzia" className="w-full flex-1" style={{ minHeight: "calc(100vh - 80px)" }} data-testid="certificato-page" />
      ) : (
        <div className="flex flex-1 items-center justify-center text-slate-300"><Loader2 className="mr-2 h-5 w-5 animate-spin" /> Generazione contratto…</div>
      )}
    </div>
  );
}
